import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
  CartesianGrid,
} from 'recharts';
import styled from 'styled-components';
import { getPrettyMonth } from './utility';

const P = styled.p`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2rem;
  padding: 1rem 1rem 1rem 0rem;
`;

const StyledChartWrapper = styled.div`
  width: 100%;
  padding: 1rem 1rem;
  @media screen and (max-width: 900px) {
    padding: 0rem;
  }
`;

type Payload = {
  name: string;
  label: string;
  value: number;
  fill: string;
};

export interface ShareHoldingPatternItem {
  yearlyRecordCount: number;
  DIIMFPer: number;
  FIIPer: number;
  insurancePer: number;
  mutualFundsPer: number;
  othersPer: number;
  promotersPer: number;
}

interface StockBarChartProps {
  activeData: Payload;
  shareHoldingData: Array<ShareHoldingPatternItem>;
}

export const StockBarChart: React.FC<StockBarChartProps> = ({
  activeData,
  shareHoldingData,
}) => {
  const getXAxisFontSize = () => {
    if (window.innerWidth < 900) {
      return 10;
    } else {
      return 16;
    }
  };

  const activeDataSet = shareHoldingData.map((current) => {
    return {
      xAxis: getPrettyMonth(current.yearlyRecordCount),
      yAxis: current[activeData.name as keyof ShareHoldingPatternItem],
      yAxisBarLabel:
        (
          current[activeData.name as keyof ShareHoldingPatternItem] || 0
        ).toFixed(2) + '%',
    };
  });

  return (
    <StyledChartWrapper>
      <P>{activeData.label}</P>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={activeDataSet}>
          <XAxis
            dataKey="xAxis"
            fontSize={getXAxisFontSize()}
            axisLine={false}
            tickLine={false}
          />
          <CartesianGrid vertical={false} stroke="#e0e0e0" />
          <YAxis
            axisLine={false}
            fontSize={14}
            tickLine={false}
            ticks={[0, 25, 50, 75, 100]}
            width={30}
          />
          <Bar
            dataKey="yAxis"
            fill={activeData.fill}
            style={{ outline: 'none' }}
            radius={[5, 5, 0, 0]}
          >
            <LabelList dataKey="yAxisBarLabel" position="top" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </StyledChartWrapper>
  );
};
